import { render, staticRenderFns } from "./multModel.vue?vue&type=template&id=54b36654"
import script from "./multModel.vue?vue&type=script&lang=js"
export * from "./multModel.vue?vue&type=script&lang=js"
import style0 from "./multModel.vue?vue&type=style&index=0&id=54b36654&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports